import { type envType } from '@atlassiansox/analytics-web-client';

import { ProductIds } from '../../constants';
import type { Attributes, GlobalScriptEntry, PendoConfig, PendoEvent } from '../../types';
import { ChoreographerPlugin } from '../ChoreographerPlugin';

/*
 * This plugin is designed to work with the Pendo agent, which is a third-party tool that is loaded into
 * the application by the products and is stored in window.pendo. This plugin essentially creates a proxy
 * object for the Pendo instance, which allows us to intercept and decorate certain functions within the
 * pendo API as they are set.
 */
export class PendoChoreographerPlugin extends ChoreographerPlugin {
	private currentMessageId: string = '';

	constructor(envType: envType, metaMetricsData: Attributes = {}) {
		super(ProductIds.PENDO, envType, metaMetricsData);
	}

	public getPendoConfig = (
		pendoConfig: PendoConfig,
	): {
		guides: {
			globalScripts: GlobalScriptEntry[];
		};
	} => {
		// eslint-disable-next-line @typescript-eslint/no-this-alias
		const pendoPlugin = this;

		return {
			...pendoConfig,
			guides: {
				...(pendoConfig.guides ?? {}),
				globalScripts: [
					...(pendoConfig.guides?.globalScripts ?? []),
					{
						beforeMount(evnt: PendoEvent) {
							if (pendoPlugin.state.isDisabled) {
								evnt.cancel = true;
							} else {
								pendoPlugin.currentMessageId = evnt.step.id;
								pendoPlugin.on(pendoPlugin.currentMessageId, {});
								void pendoPlugin.startMessage(pendoPlugin.currentMessageId);
							}
						},
						unmounted() {
							void pendoPlugin.stopMessage(pendoPlugin.currentMessageId);
						},
					} as GlobalScriptEntry,
				],
			},
		};
	};

	override isDisplayingMessage(): boolean {
		return Boolean(window.pendo?.getActiveGuide?.());
	}
}
